import React from 'react';
import { ClockIcon, CalendarXIcon, UsersIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { COST_STATS } from '../../data/content';
const ICONS = [CalendarXIcon, ClockIcon, UsersIcon];
export function SocialStats() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-231" data-mp="1gj12ovnc9f0a">
      <div className="mx-auto max-w-5xl" data-id="element-232" data-mp="1ggoc5u3ilwbm">
        <Reveal className="text-center" data-id="element-233" data-mp="1lidln5b3a1xl">
          <SectionBadge data-id="element-234" data-mp="1lhlse14ysgah">El problema real</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-235" data-mp="1qgf9s4ndgrfx">
            El verdadero costo de <span className="u-lime" data-id="element-236" data-mp="1v86zkcypet50">preparar tus clases desde cero</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-snow-muted sm:text-base" data-id="element-237" data-mp="1z87fk21gbce6">
            No es solo el tiempo que perdés. Es la <strong className="font-bold text-snow" data-id="element-238" data-mp="246ima3wg96s6">energía</strong>, la{' '}
            <strong className="font-bold text-snow" data-id="element-239" data-mp="297yb871qzxfu">variedad</strong> y las alumnas que se van.
          </p>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-3" data-id="element-240" data-mp="3b60vtcmyb11b">
          {COST_STATS.map((stat, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <Reveal key={stat.title} delay={index * 80} as="article" data-id="element-241" data-mp="329t8bqc5sy83" data-mpi={index}>
                <div className="h-full rounded-2xl border border-white/10 bg-ink/90 p-5 text-left sm:p-6" data-id="element-242" data-mp="2x9xegjx6en69">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-lime/15 text-lime" data-id="element-243" data-mp="3tyd6qnro7an2">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-244" data-mp="3py2yt5kbia5k" />
                  </span>
                  <p className="mt-4 font-display text-4xl leading-none text-lime" data-id="element-245" data-mp="3l501qngc0ikm">{stat.value}</p>
                  <p className="mt-1 text-xs font-extrabold uppercase tracking-[0.16em] text-snow-dim" data-id="element-246" data-mp="3g6yk86yk0rb9">
                    {stat.unit}
                  </p>
                  <h3 className="mt-4 text-base font-bold text-snow" data-id="element-247" data-mp="cq83ax1fotus">{stat.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-snow-muted" data-id="element-248" data-mp="vn9wus3otrgk">{stat.desc}</p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}